
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"11","viewBox":"0 0 74.6 30.6"}},[_c('path',{staticClass:"st0",attrs:{"d":"M66.5 13h-59l9.1-9.4c.4-.4.6-.9.6-1.4 0-.5-.2-1-.6-1.4-.8-.8-2-.8-2.7 0L1.6 13.5c-.1.1-.2.4-.3.6-.1.2-.1.3-.1.5v.9c0 .2.1.4.2.6 0 .1.1.2.2.3l12.2 12.7c.4.4.9.6 1.4.6s1-.2 1.4-.6c.4-.4.6-.9.6-1.4 0-.5-.2-1-.6-1.3l-9.1-9.6h59.1c1.1 0 1.9-.8 1.9-1.9s-.9-1.9-2-1.9z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      